export default __webpack_public_path__ + "static/media/upload-icon.baa6cc09.svg";